import { Drawer, Grid } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import React from "react"
import ItemMenuLateral from "./ItemMenuLateral"

const MenuLateral = (props) => {
	const classes = useStyles()

	return (
		<Drawer className={classes.drawer} variant="permanent" classes={{ paper: classes.drawerPaper }} anchor="left">
			<Grid container>
				<Grid key="logo" item>
					{props.logo}
				</Grid>
				{props.itens.map((item) => {
					return (
						<Grid key={item.nome} className={classes.item} item>
							<ItemMenuLateral label={item.nome} goTo={item.rota} icone={item.icone} linkInterno={item.linkInterno} />
						</Grid>
					)
				})}
			</Grid>
		</Drawer>
	)
}

//TODO - Fix this static value
const drawerWidth = 81
const useStyles = makeStyles((theme) => ({
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
	},
	drawerPaper: {
		width: drawerWidth,
		backgroundColor: "#20174A",
	},
	toolbar: theme.mixins.toolbar,
	item: {
		paddingBottom: '5px',
	}
}))

export default MenuLateral
